import budget from "assets/images/Budget.svg";
import distance from "assets/images/Distance.svg";
import duration from "assets/images/Duration.svg";

export const DashoardServiceData = [
  {
    id: 1,
    image: duration,
    heading: "For any duration",
    desc: "Easily plan a day out without having to worry about conveyance with an hour-based package from Rental.",
  },
  {
    id: 2,
    image: distance,
    heading: "For any distance",
    desc: "Book Homes within the city with Daily, or take a trip to your favourite destinations outside the city with Outstation.",
  },
  {
    id: 3,
    image: budget,
    heading: "For any budget",
    desc: "From Bikes and Autos to Prime Sedans and Prime SUVs, you will find a Home in your budget at your convenience any time.",
  },
];
